import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ChipModule } from 'primeng/chip';
import { PanelModule } from 'primeng/panel';
import { COMMON_IMPORTS } from '../../common-imports';
import { SingleMyopRiskAt18Result } from '../../backend-response-models/calc-enums.helper';
import { TranslatePipe } from '../../languages/translate.pipe';
import Mustache from 'mustache';

@Component({
  selector: 'app-myopia-single-eim-retest',
  standalone: true,
  imports: [...COMMON_IMPORTS, PanelModule, ChipModule],
  templateUrl: './myopia-single-eim-retest.component.html',
  styleUrl: './myopia-single-eim-retest.component.css',
})
export class MyopiaSingleEimRetestComponent implements OnInit, OnChanges {
  @Input({ required: true })
  retestMonths!: number;

  @Input({ required: true })
  singleMyopRiskAt18Result!: SingleMyopRiskAt18Result;

  @Input({ required: true })
  serAtLastVisit!: number;

  @Input({ required: true })
  ageAtLatestVisitInYears!: number;

  @Input()
  personalization?: string;

  public eimString: string = 'blank';
  public retestString: string = 'blank';
  public greyColor = '#808080';
  public whiteColor = '#FFFFFF';

  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit(): void {
    this.refresh();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes: SimpleChanges): void {
    this.refresh();
  }

  refresh() {
    const translationMyopiaLevelKeys: Record<SingleMyopRiskAt18Result, string> = {
      [SingleMyopRiskAt18Result.LOW]: 'LOW_LEVEL_OF_MYOPIA',
      [SingleMyopRiskAt18Result.MEDIUM]: 'MODERATE_LEVEL_OF_MYOPIA',
      [SingleMyopRiskAt18Result.HIGH]: 'HIGH_LEVEL_OF_MYOPIA',
    };

    const AGE_AT_LATEST_VISIT = this.ageAtLatestVisitInYears;
    const SER_AT_LAST_VISIT = this.serAtLastVisit.toFixed(2);
    const LEVEL_OF_MYOPIA = this.translatePipe.transform(translationMyopiaLevelKeys[this.singleMyopRiskAt18Result]);

    let LENGTH = this.retestMonths;
    let LENGTH_SUFFIX = this.translatePipe.transform('MONTHS');

    if (this.retestMonths == 12) {
      LENGTH = this.retestMonths / 12;
      LENGTH_SUFFIX = this.translatePipe.transform('YEAR');
    } else if (this.retestMonths == 24) {
      LENGTH = this.retestMonths / 12;
      LENGTH_SUFFIX = this.translatePipe.transform('YEARS');
    } else {
      LENGTH = this.retestMonths;
      LENGTH_SUFFIX = this.translatePipe.transform('MONTHS');
    }

    const moustacheTemplateEim = this.translatePipe.transform('MYOPIA_SINGLE_VISIT_EIM_TEMPLATE');
    const moustacheTemplateRetest = this.translatePipe.transform('MYOPIA_SINGLE_VISIT_EIM_RETEST_BRIEF');

    const noNameName = this.translatePipe.transform('NO_NAME_NAME');
    const renderedEimTemplate = Mustache.render(moustacheTemplateEim, {
      PERSONALIZED_NAME_CAPITALIZED: this.personalization ?? noNameName,
      AGE_AT_LATEST_VISIT,
      SER_AT_LAST_VISIT,
      LEVEL_OF_MYOPIA,
      LENGTH,
      LENGTH_SUFFIX,
    });
    const renderedRetestTemplate = Mustache.render(moustacheTemplateRetest, {
      LENGTH,
      LENGTH_SUFFIX,
    });

    this.eimString = renderedEimTemplate;
    this.retestString = renderedRetestTemplate;
  }
}
